(function () {
    'use strict';

    angular.module("imApp").factory("cargonizerPrinterEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 426,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 427,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
